// http://myglobe.local/api/quality/guardians/placed?start=2018-03-08&end=2018-03-16&group-by=1

var datepickers = require('./datepickers');

const MONTHS = ['December', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November'];
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var chartConfig = {
    type: 'line',
    data: {
        labels: DAYS,
        datasets: [
            {
                label: '',
                backgroundColor: 'rgba(79,188,189,1)',
                borderColor: 'rgba(79,188,189,1)',
                data: [],
                fill: false,
                borderWidth: 2
            }, {
                label: '',
                backgroundColor: 'rgba(232,61,83,1)',
                borderColor: 'rgba(232,61,83,1)',
                data: [],
                fill: false,
                borderWidth: 2
            }
        ]
    },
    options: {
        responsive: true,
        legend: {
            position: 'bottom',
            labels: {
                defaultFontFamily: "'Montserrat', sans-serif",
                fontWeight: '700',
                defaultFontColor: "5d5a5b"
            }
        },
        tooltips: {
            mode: 'index',
            intersect: false,
        },
        hover: {
            mode: 'nearest',
            intersect: true
        },
        scales: {
            xAxes: [{
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Month'
                },
                gridLines: {
                    color: 'rgba(93,90,91,1)',
                    lineWidth: 1
                }
            }],
            yAxes: [{
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Placed Guardians'
                },
                ticks: {
                    beginAtZero: true,
                    suggestedMax: 10,
                },
                gridLines: {
                    color: 'rgba(93,90,91,1)',
                    lineWidth: 1
                }
            }]
        }
    }
}

var canvas = document.getElementById("myChart").getContext('2d');

function renderChart(canvas) {
    return new Chart(canvas, chartConfig);
}

// Change chart type - lines or bars
function changeChartType(typeOfChart) {
    if (chartConfig.type == typeOfChart) {
        return;
    }

    chartConfig.type = typeOfChart;
    for (var i = 0; i < chartConfig.data.datasets.length; i++) {
        chartConfig.data.datasets[i].type = typeOfChart;
    }

    window.myChart.update();
}

// Change X axis labels
function changeChartLabels(dateType) {
    if (dateType == "DAYS") {
        chartConfig.data.labels = DAYS;
        setXAxesLabel('Day');
    } else if (dateType == "MONTHS") {
        chartConfig.data.labels = MONTHS;
        setXAxesLabel('Month');
    } else {
        chartConfig.data.labels = [];
        setXAxesLabel('Week');
    }

    window.myChart.destroy();
    window.myChart = renderChart(canvas);
}

// Set X axes main label
function setXAxesLabel(label) {
    chartConfig.options.scales.xAxes[0] = {
        display: true,
        scaleLabel: {
            display: true,
            labelString: label
        }
    };
}

// function setChartDataLabels(datepicker, differenceBetweenDates) {
function setChartDataLabels() {
    let dateType = $('input[name=radioPeriod]:checked').val();
    var dateFormat;
    var stepType;

    if (dateType == "MONTHS") {
        stepType = "months";
        dateFormat = 'M';
    } else if (dateType == "DAYS") {
        stepType = "days";
        dateFormat = 'd';
    } else {
        stepType = "weeks";
        dateFormat = "w";
    }

    var min = datepickers.$datepickers[0];
    var max =  datepickers.$datepickers[0];

    // Get min and max date from
    for (var i = 0; i < datepickers.$datepickers.length; i++) {
        if (datepickers.$datepickers[i].data('date')) {
            // // Compare min date
            // var formattedNow = window.moment(datepickers.$datepickers[i].data('date'), 'DD-MM-YYYY').format('YYYY-MM-DD');
            // var formattedMin = window.moment(min.data('date'), 'DD-MM-YYYY').format('YYYY-MM-DD');
            // if (window.moment(formattedNow).isSameOrBefore(window.moment(formattedMin))) {
            //     min = datepickers.$datepickers[i];
            // }

            // Compare max date
            var formattedNow = window.moment(datepickers.$datepickers[i].data('date'), 'DD-MM-YYYY').format('YYYY-MM-DD');
            var formattedMax = window.moment(max.data('date'), 'DD-MM-YYYY').format('YYYY-MM-DD');
            if (window.moment(formattedNow).isSameOrAfter(window.moment(formattedMax))) {
                max = datepickers.$datepickers[i];
            }
        }
    }

    // Get how many days/weeks/months is between dates (min and max)
    var daysBetween = datepickers.dateRange(min.data('date'), max.data('date'), stepType);

    var newArrayOfLabels = [];

    /**For each day/week/month
    * format the date so it can be manipulated
    * add next day/week/month
    * write it to the array with correct format */
    for (var i = 0; i <= daysBetween; i++) {
        let dataToBeDisplayed = window.moment(min.data('date'), 'DD-MM-YYYY').format('YYYY-MM-DD');
        dataToBeDisplayed = window.moment(dataToBeDisplayed).add(i, dateFormat);

        if (stepType === 'days') {
            newArrayOfLabels.push(window.moment(dataToBeDisplayed, 'DD-MM-YYYY').format('dddd, D MMM'));
        } else if (stepType === 'weeks') {
            newArrayOfLabels.push(window.moment(dataToBeDisplayed, 'DD-MM-YYYY').format('D MMM, Wo [week of] YYYY'));
        } else {
            newArrayOfLabels.push(window.moment(dataToBeDisplayed, 'DD-MM-YYYY').format('MMM YYYY'));
        }
    }

    chartConfig.data.labels = newArrayOfLabels;
    window.myChart.update();
}

// Get and set new dataset from between two dates
// function getNewDataset(datepicker, index, newDate, isStartDate, differenceBetweenDates) {
function getNewDataset(dateType, datasetNumber) {
    var from;
    var to;

    // If this is a second dataset then change index to 2 (so 3rd and 4th datepicker can be choosen)
    if (datasetNumber == 1) {
        datasetNumber = 2;
    }

    if (datepickers.$datepickers[datasetNumber].data('date') && datepickers.$datepickers[+datasetNumber + 1].data('date')) {
        from = datepickers.$datepickers[datasetNumber].data('date');
        to = datepickers.$datepickers[+datasetNumber + 1].data('date');

        getNewDatasetFromDB(from, to, dateType, datasetNumber);
    }
}

// This function will hold all db logic
function getNewDatasetFromDB(from, to, dateType, datasetNumber) {
    var timePeriod;

    if (dateType == "MONTHS") {
        timePeriod = 3;
    } else if (dateType == "DAYS") {
        timePeriod = 1;
    } else {
        timePeriod = 2;
    }

    var start = window.moment(from, 'DD-MM-YYYY').format('YYYY-MM-DD');
    var end = window.moment(to, 'DD-MM-YYYY').format('YYYY-MM-DD');

    var newDataSet = [];

    $.ajax({
        type: "GET",
        url: $('#chartsSection').data('url'),
        data: {
            start: start,
            end: end,
            "group-by": timePeriod
        },
        beforeSend: function () {
            //    something
        },
        success: function (response) {
            var values = response.values;
            values.map(x => newDataSet.push(x));
            setNewDataset(newDataSet, datasetNumber);
        },
    });

}

// Update chart with new dataset
function setNewDataset(newData, datasetNumber) {
    // Switch to 1 to update second dataset
    if (datasetNumber == 2) {
        datasetNumber = 1;
    }

    chartConfig.data.datasets[datasetNumber].data = newData;
    window.myChart.update();

    setChartDataLabels();
}

function changeDatasetLabels() {
    for (var i = 0; i < datepickers.$datepickers.length; i += 2) {
        if (datepickers.$datepickers[i].data('date') && datepickers.$datepickers[+i + 1].data('date')) {
            var startDate = datepickers.$datepickers[i].data('date');
            var endDate = datepickers.$datepickers[+i + 1].data('date');
            var toUpdate = i <= 0 ? i : i - 1;
            chartConfig.data.datasets[toUpdate].label = "Guardians placed between " + window.moment(startDate, 'DD-MM-YYYY').format('DD-MM-YYYY') + " and " + window.moment(endDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
        }
    }
}

$(document).ready(function () {
    window.myChart = renderChart(canvas);

    // If button "line" or "bar" clicked - change chart type
    $('.button__change-type').on("click", function (e) {
        changeChartType($(this).data("type"));
    });

    // If radio button clicked - change chart labels
    $('input[name=radioPeriod]').on("change", function (e) {
        changeChartLabels($(this).attr("value"));

        // Get new dataset
        getNewDataset($('input[name=radioPeriod]:checked').val(), 0);

        // Get also new dataset if second date row needs to be compared
        if ($("input[name=compareTime]").is(':checked')) {
            // Get difference between two dates
            // var differenceBetweenDates = datepickers.countDifferenceBetweenDates(2);
            getNewDataset($('input[name=radioPeriod]:checked').val(), 1);
        }

        changeDatasetLabels();
    });

    // If checkbox clicked - display row to compare dates
    $('input[name=compareTime]').on("change", function (e) {
        $("#secondDatepickersRow").toggle();

        // Hide dataset
        if ($("#secondDatepickersRow").css('display') == 'none') {
            chartConfig.data.datasets[1].hidden = true;
        } else {
            chartConfig.data.datasets[1].hidden = false;
        }

        window.myChart.update();
    });

    // onClick action for each datepicker
    datepickers.$datepickers.map((el, i) => {
        el.on("dp.change", function (e) {
            var isStartDate = (i % 2) ? true : false;

            // Change max/min date of related datepicker
            datepickers.changeDate(i, e.date, isStartDate);

            var datasetNumber = $(el).attr("datasetNumber");

            // Get new dataset
            getNewDataset($('input[name=radioPeriod]:checked').val(), datasetNumber);

            if (datasetNumber <= 1) {
                // Get also new dataset if second date row needs to be compared
                if ($("input[name=compareTime]").is(':checked')) {
                    // Get difference between two dates
                    // var differenceBetweenDates = datepickers.countDifferenceBetweenDates(2);
                    getNewDataset($('input[name=radioPeriod]:checked').val(), 1);
                }
            }

            changeDatasetLabels();
        });
    })


});
